import { Router } from '@angular/router';
import { NotificacaoTipoEnum } from '../../core/enum/notificacao-tipo-enum';
import { BsModalService } from 'ngx-bootstrap/modal';
import { NotificacoesHubService } from '../../core/services/notificacoes/notificacoesHub.service';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { SituacaoNotificacaoEnum } from 'src/app/core/enum/situacao-notificacao-enum';

@Component({
  selector: 'app-modal-notificacoes',
  templateUrl: './modal-notificacoes.component.html',
  styleUrls: ['./modal-notificacoes.component.scss'],
})
export class ModalNotificacoesComponent implements OnInit {
  @Output() fecharModal: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    public notificacoesHubService: NotificacoesHubService,
    public bsModalService: BsModalService,
    private router: Router
  ) {}

  ngOnInit() {
    setTimeout(() => {
      this.notificacoesHubService.atualizarNotificacoesPorSituacao(
        SituacaoNotificacaoEnum.recebida,
        SituacaoNotificacaoEnum.visualizada
      );
    }, 2000);
  }

  public redirecionarParaPaginaByTipo(tipo: NotificacaoTipoEnum) {
    switch (tipo) {
      case NotificacaoTipoEnum.decisaoManualCobranca:
        this.router.navigate(['/debito-manual-similaridade']);
        this.bsModalService.hide(1);
        break;

      default:
        break;
    }
  }
}
